import styled from "styles/styled_components";
import ellipsis from "styles/ellipsis";
import { IThemeInterface } from "styles/theme";

enum BORDERS {
  UNASSIGNED_WEEK,
  UNASSIGNED_DAY,
  SHIFT_WEEK,
  SHIFT_DAY,
  FULL,
  SIDES,
  NONE,
}

interface IStyledTimeBlock {
  border?: BORDERS;
}

function makeBorderRules(theme: IThemeInterface, borderWidths: string) {
  return `
    border: ${theme.lightBorder};
    border-width: ${borderWidths};
    padding: ${theme.indicatorBorder} ${theme.spacing.small} 1px;
  `;
}

const StyledTimeBlock = styled("div")<IStyledTimeBlock>`
  background-color: ${({ theme }) => theme.colors.brandWhite};
  ${({ border, theme }) => {
    // Rules are:
    // - Unassigned has a bottom border
    // - Assigned doesn't
    // - Day view has side borders
    // - Week view doesn't
    switch (border) {
      case BORDERS.UNASSIGNED_WEEK:
        // Top and bottom
        return makeBorderRules(theme, `${theme.indicatorBorder} 0 1px 0`);
      case BORDERS.UNASSIGNED_DAY:
        // Top bottom and sides
        return makeBorderRules(theme, `${theme.indicatorBorder} 1px`);
      case BORDERS.SHIFT_WEEK:
        // Top only
        return makeBorderRules(theme, `${theme.indicatorBorder} 0 0`);
      case BORDERS.SHIFT_DAY:
        // Top and sides only
        return makeBorderRules(theme, `${theme.indicatorBorder} 1px 0`);
      case BORDERS.FULL:
        return `
          border: ${theme.lightBorder};
          padding: 5px ${theme.spacing.small} 0;
        `;
      case BORDERS.SIDES:
        // Sides only
        return `
          border: ${theme.lightBorder};
          border-width: 0 1px;
          padding: 5px ${theme.spacing.small} 0;
        `;
      case BORDERS.NONE:
      default:
        return `
          padding: 5px ${theme.spacing.small} 0;
        `;
    }
  }}
  color: ${({ theme }) => theme.colors.brandGray40};
  height: ${({ theme }) => theme.rawShiftHeight}px;
  line-height: ${props => props.theme.text.lineHeight.small};
  position: relative;
  text-align: left;
`;

const StyledTime = styled.span`
  display: block;
  ${ellipsis}
`;

const StyledRole = styled.span`
  color: ${({ theme }) => theme.colors.brandGray40};
  display: block;
  font-family: ${props => props.theme.text.mediumFamily};
  letter-spacing: 1px;
  margin-right: ${({ theme }) => theme.spacing.small};
  max-width: 100%;
  text-transform: uppercase;
  ${ellipsis}
`;

export const StyledTotalHours = styled(StyledRole)`
  letter-spacing: 0;
`;

export { StyledTimeBlock, StyledTime, StyledRole, IStyledTimeBlock, BORDERS };
